import styled from "styled-components";
import introduceBg from "@/assets/introduce-bg.png";
import textDco from "@/assets/text-dco.png";
import downloadBtn from "@/assets/download.png";
import qrCode from "@/assets/下载区服务号二.png";
const Introduce = () => {
  const download = () => {
    window.open("https://jx.xoyo.com/index1/xz.html");
  };
  return (
    <Container>
      <img src={introduceBg} alt="" className="bg" />
      <div className="des"></div>
      <img
        className="download"
        src={downloadBtn}
        alt=""
        onClick={download}
      ></img>

      <img className="we-chat-code" src={qrCode} alt="" />
    </Container>
  );
};

export default Introduce;

const Container = styled.div`
  width: 100%;
  height: 18rem;
  position: relative;
  & > * {
    position: absolute;
  }
  .bg {
    width: 71.6rem;
    height: 22.63rem;
    top: -6rem;
    left: 2.5%;
  }
  .des {
    position: absolute;
    left: 10%;
    top: -1.5rem;
    width: 37.5rem;
    height: 7.75rem;
    background: url(${textDco});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;
  }
  .download {
    height: 4.13rem;
    left: 11.5%;
    bottom: 6rem;
    cursor: pointer;
  }
  .we-chat-code {
    height: 14rem;
    position: absolute;
    left: 64%;
    top: -2.3rem;
  }
`;
